import { Route, Routes } from "react-router-dom";

import { AddRule } from "./AddRule";
import { EditRule } from "./EditRule";
import RulesView from "./RulesView";

const RulesRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<RulesView />} />
      <Route path="/add" element={<AddRule />} />
      <Route path="/:ruleId" element={<EditRule />} />
    </Routes>
  );
};

export default RulesRouter;
